/**
 * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
 * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
 *
 * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
 */

import digest from 'core/digest';

/**
 * Hash text using the core digest service.
 * @param {string} text
 * @returns {Promise<string>}
 */
export function hashText(text) {
    return digest(text, 'SHA-256');
}

/**
 * Split the hash into readable chunks, matching the CurrentGen watermark behavior.
 * If the hash length is not divisible by the configured part length, the leftover is not rendered.
 * @param {string} hash
 * @param {number|string} [textPartLength]
 * @param {number|string} [separatorsLength]
 * @returns {string}
 */
export function formatHash(hash, textPartLength = 10, separatorsLength = 3) {
    const partLength = Math.max(1, Math.min(parseInt(textPartLength, 10) || 10, hash.length));
    const separator = ' '.repeat(Math.max(0, parseInt(separatorsLength, 10) || 0));
    const parts = [];

    for (let index = 0; index < hash.length - partLength + 1; index += partLength) {
        parts.push(hash.slice(index, index + partLength));
    }

    return `${parts.join(separator)}${separator || ' '}`;
}
